import styled from 'styled-components'

export const PostModalFooterContainer = styled.div<{ $isFullscreen: boolean }>`
  gap: var(--spacer-3);
  height: ${(props) => (props.$isFullscreen ? '5.625rem;' : 'auto')};
`

PostModalFooterContainer.displayName = 'PostModalFooterContainer'
